export default __webpack_public_path__ + "img/program4.03d2fb11.svg";